module.exports = __webpack_public_path__ + "static/anna_after-ae5e464ae458be973a2b50c15f28da46.jpg";